(() => {
  const urlParams = window.location.search;
  const utmCampaign = 'utm_campaign=';
  const isCampaign = urlParams.search(new RegExp(utmCampaign)) > -1;
  const couponsData = {
    'HLN00CPO-AP-BoF-3months': {
      cp: '3MONTHFREEALL_DGTL',
      txt: 'first 3 months free',
    },
    'HLN00CPO-AP-BoF-25off': {
      cp: '25%OFF-DGTL',
      txt: '25% off',
    },
  };

  if (!isCampaign) return;
  const campaignCodeRegex = new RegExp(`(?:[?&])${utmCampaign}(.*?(?=&|$))`);
  const utmCampaignCode = urlParams.match(campaignCodeRegex)[1];
  const coupSect = document.getElementById('coupon-sect');
  const benefitsTextObj = coupSect.querySelector('.benefits-text');
  const couponTextObj = coupSect.querySelector('.coupon-sect__code');
  // const benefitsData = JSON.parse(benefitsTextObj.getAttribute('data-benefits'));

  benefitsTextObj.textContent = couponsData[utmCampaignCode].txt;
  couponTextObj.textContent = couponsData[utmCampaignCode].cp;

  document.documentElement.classList.add('show-coupon');
})();
